import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AdjustQuestionScoreModel, IExam, MarkingQuestionModel, SaqCandidateQuestionModel } from 'src/app/interface/dto';
import { ExamScheduleService } from 'src/app/services/exam-schedule-service';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog.service';
import { ScoreAdjustmentModalComponent } from '../../Shared/score-adjustment-modal/score-adjustment-modal.component';
declare var $: any
@Component({
  selector: 'app-mark-saq',
  templateUrl: './mark-saq.component.html',
  styleUrls: ['./mark-saq.component.scss']
})
export class MarkSaqComponent implements OnInit {
  mode: string = 'mark';
  candidatesQuestionsData: SaqCandidateQuestionModel[] = [];
  candidateCount: number = 0;
  candidateMarkedCount: number = 0;
  candidateUnmarkedCount: number = 0;
  showPendingOnly: boolean = false;
  examination: IExam;
  selectedCandidateQuestion: SaqCandidateQuestionModel = null;
  adjustmentData = {
    score: 0,
    reason: ''
  };
  loadingQuestions: boolean = false;

  constructor(private snackBar: SnackbarService,
    private examService: ExamService,
    private examSchService: ExamScheduleService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private confirmDialog: ConfirmDialogService) { }

  async ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.mode = params['mode'] || 'mark';
    });

    let selectedExamID = this.examService.selectedExamIds[0];
    this.examination = this.examService.selectedExams[0];
    let selectedSchID = (this.examSchService.selectedIds && this.examSchService.selectedIds[0]) ?? 0;
    //console.log("SELECTED SCHEDULE:", selectedSchID);
    let data = { ExaminationScheduleID: selectedSchID, ExaminationID: selectedExamID, Mode: this.mode };
    
    const res = await this.examService.getSaqCandidates(data);
    this.candidatesQuestionsData = (res?.saqCandidates ?? []).map(c => ({ ...c, essayQuestionModels: [] }));
    this.candidateCount = res?.candidateCount ?? 0;
    this.candidateMarkedCount = res?.candidateMarkedCount ?? 0;
    this.candidateUnmarkedCount = res?.candidateUnmarkedCount ?? 0;
  }

  async loadCandidateQuestions(data: SaqCandidateQuestionModel) {
    this.selectedCandidateQuestion = data;

    const buttons = document.querySelectorAll('.canlist');
    buttons.forEach(button => button.classList.remove('active'));
    const activeButton = document.getElementById(data.examNo.toString());
    if (activeButton) activeButton.classList.add('active');

    if (!data.essayQuestionModels || data.essayQuestionModels.length === 0) {
      this.loadingQuestions = true;
      try {
        const questionsData = {
          ExaminationID: this.examination.id,
          ExaminationScheduleID: data.examinationScheduleID,
          Mode: this.mode,
        };

        const questions = await this.examService.getSaqQuestions(questionsData);

        const candIndex = this.candidatesQuestionsData.findIndex(c => c.examNo === data.examNo);
        if (candIndex !== -1) {
          this.candidatesQuestionsData[candIndex].essayQuestionModels = questions;
          this.selectedCandidateQuestion = this.candidatesQuestionsData[candIndex];
        }
      } catch {
        this.snackBar.error('Failed to load questions for candidate');
      } finally {
        this.loadingQuestions = false;
      }
    }

    const topElement = document.getElementById('scrollToTop');
    if (topElement) topElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  get filteredCandidates(): SaqCandidateQuestionModel[] {
    if (!this.showPendingOnly) return this.candidatesQuestionsData;
    return this.candidatesQuestionsData.filter(cand =>
      this.mode === 'review' ? !cand.reviewed : !cand.marked
    );
  }

  onPendingFilterChange() {
    const stillVisible = this.filteredCandidates.find(
      c => c.examNo === this.selectedCandidateQuestion?.examNo
    );

    if (!stillVisible && this.filteredCandidates.length > 0) {
      this.loadCandidateQuestions(this.filteredCandidates[0]);
    }
  }

  calculateTotalScore(candidate: SaqCandidateQuestionModel) {
    return candidate.essayQuestionModels?.reduce((acc, q) => acc + (q.markEarned || 0), 0) ?? 0;
  }

  async markCorrect(_t15: MarkingQuestionModel, index: number, examNo: string) {
    const candIndex = this.candidatesQuestionsData.findIndex(c => c.examNo == examNo);
    if (this.candidatesQuestionsData[candIndex].essayQuestionModels[index].answerStatusString == 'Correct') {
      return;//no need to mark correct since it's already correct
    }
    this.candidatesQuestionsData[candIndex].essayQuestionModels[index].markEarned = _t15.mark;
    _t15.answerStatusString = "Correct";
    _t15.answerStatusValue = "Correct";

    this.candidatesQuestionsData[candIndex].essayQuestionModels[index].answerStatusString = _t15.answerStatusString
    await this.examService.markSAQQuestion(_t15);

  }
  async markIncorrect(_t15: MarkingQuestionModel, index: number, examNo: string) {
    let candIndex = this.candidatesQuestionsData.findIndex(c => c.examNo == examNo);
    if (this.candidatesQuestionsData[candIndex].essayQuestionModels[index].answerStatusString == 'Incorrect') {
      return;
    }
    _t15.answerStatusString = "Incorrect";
    _t15.answerStatusValue = "Incorrect";
    this.candidatesQuestionsData[candIndex].essayQuestionModels[index].markEarned = 0;
    this.candidatesQuestionsData[candIndex].essayQuestionModels[index].answerStatusString = _t15.answerStatusString;
    await this.examService.markSAQQuestion(_t15);
  }
  get totalMarkedCandidates() {
    return this.candidatesQuestionsData.filter(cand => cand.marked).length
  }
  get totalUnMarkedCandidates() {
    return this.candidatesQuestionsData.filter(cand => !cand.marked).length
  }
  get totalCandidatesReviewed() {
    return this.candidatesQuestionsData.filter(cand => cand.reviewed).length
  }
  get totalCandidatesPending() {
    return this.candidatesQuestionsData.filter(cand => !cand.reviewed).length
  }
  openAdjustScoreModal(_t15: MarkingQuestionModel, index: number, examNo: string) {
    const modalRef = this.modalService.open(ScoreAdjustmentModalComponent, { centered: true });

    modalRef.componentInstance.currentScore = _t15.markEarned;
    modalRef.componentInstance.maxScore = _t15.mark;
    modalRef.componentInstance.questionId = _t15.esqId;
    modalRef.componentInstance.questionNo = _t15.questionNo;
    modalRef.componentInstance.examinationType = 'SAQ';
    modalRef.componentInstance.answerStatusString = _t15.answerStatusString;

    modalRef.result.then((result: AdjustQuestionScoreModel) => {
      if (result) {
        // if (result.adjustedScore === _t15.markEarned && _t15.answerStatusString != 'NotMarked') {
        //   this.snackBar.warning('No adjustment applied since the current score matches the adjusted score.');
        //   return;
        // }
        this.adjustScore(result, _t15, index, examNo);
      }
    }, (reason) => {
      // Modal dismissed
    });
  }

  async adjustScore(adjustmentData: AdjustQuestionScoreModel, _t15: MarkingQuestionModel, index: number, examNo: string) {
    try {
      await this.examService.adjustQuestionScore(adjustmentData);

      const candIndex = this.candidatesQuestionsData.findIndex(c => c.examNo == examNo)
      this.candidatesQuestionsData[candIndex].essayQuestionModels[index].markEarned = adjustmentData.adjustedScore;
      this.candidatesQuestionsData[candIndex].reviewed = false;
      const answerStatus = adjustmentData.adjustedScore === _t15.mark ? "Correct" : "Incorrect";
      _t15.answerStatusString = answerStatus;
      _t15.answerStatusValue = answerStatus;

      this.snackBar.success('Score adjusted successfully');
    } catch (error) {
      this.snackBar.error('Failed to adjust score');
    }
  }

  hasNextCandidate() {
    if (!this.filteredCandidates?.length || !this.selectedCandidateQuestion) return false;
    const currentIndex = this.filteredCandidates.findIndex(q => q.examNo === this.selectedCandidateQuestion.examNo);
    return currentIndex < this.filteredCandidates.length - 1;
  }

  hasPreviousCandidate() {
    if (!this.filteredCandidates?.length || !this.selectedCandidateQuestion) return false;
    const currentIndex = this.filteredCandidates.findIndex(q => q.examNo === this.selectedCandidateQuestion.examNo);
    return currentIndex > 0;
  }

  nextCandidate() {
    if (!this.hasNextCandidate()) return;
    const currentIndex = this.filteredCandidates.findIndex(q => q.examNo === this.selectedCandidateQuestion.examNo);
    this.loadCandidateQuestions(this.filteredCandidates[currentIndex + 1]);
  }

  previousCandidate() {
    if (!this.hasPreviousCandidate()) return;
    const currentIndex = this.filteredCandidates.findIndex(q => q.examNo === this.selectedCandidateQuestion.examNo);
    this.loadCandidateQuestions(this.filteredCandidates[currentIndex - 1]);
  }

  async markCandidate(origin: any) {
    if (this.selectedCandidateQuestion.essayQuestionModels.find(x => x.answerStatusString == 'NotMarked')) {
      this.snackBar.error("Please mark all questions before submitting the assessment");
      return;
    }
    
    const confirmed = await this.confirmDialog.open({
      title: 'Confirm Submission',
      message: 'Are you sure you want to submit marks for this candidate?<br>Submitting means scores cannot be updated afterward.',
      confirmText: 'Yes, Submit',
      cancelText: 'Cancel',
      size: 'lg',
      centered: true,
    });
    
    if (confirmed) {
      this.confirmSubmit();
    }
  }

  confirmSubmit() {
    try {
      let data = { ExaminationScheduleID: this.selectedCandidateQuestion.examinationScheduleID, ExaminationID: this.examination.id, Attempt: this.selectedCandidateQuestion.attempt, Mode: this.mode };
      this.examService.submitSaqCandidate(data).then((r: any) => {
        if (this.mode == 'mark') {
          this.snackBar.success("Assessment Marked")
        } else {
          this.snackBar.success("Assessment Reviewed")
        }
        let candIndex = this.candidatesQuestionsData.findIndex(c => c.examNo == this.selectedCandidateQuestion.examNo);
        this.candidatesQuestionsData[candIndex].marked = true;
        this.candidatesQuestionsData[candIndex].reviewed = this.mode == 'review';

        const allDone = this.mode === 'review'
        ? this.candidatesQuestionsData.every(c => c.reviewed)
        : this.candidatesQuestionsData.every(c => c.marked);
        
        if (allDone) {
          this.promptRequestScript();
        }
      });
    } catch (error) {
      this.snackBar.error("An error occured when submitting")
      console.log(error);
    }
  }

  loadingMoreScripts = false;

  async requestMoreScripts() {
    this.loadingMoreScripts = true;

    try {
     const res = this.mode === 'review'
      ? await this.examService.requestMoreSaqScriptsForReview(this.examination.id) as SaqCandidateQuestionModel[]
      : await this.examService.requestMoreSaqScriptsForScoring(this.examination.id) as SaqCandidateQuestionModel[];

      if (!res.length) {
        this.snackBar.info('No new scripts available at the moment');
        return;
      }

      const existing = new Set(this.candidatesQuestionsData.map(c => c.examNo));
      const newScripts = res.filter(c => !existing.has(c.examNo));

      this.candidatesQuestionsData = [
        ...this.candidatesQuestionsData,
        ...newScripts.map(s => ({ ...s, essayQuestionModels: [] }) as SaqCandidateQuestionModel)
      ];

      this.snackBar.success(`${newScripts.length} new script(s) assigned`);
      this.candidateMarkedCount = Math.max(0, this.candidateMarkedCount - newScripts.length);
      
       setTimeout(() => { 
        this.loadCandidateQuestions(this.candidatesQuestionsData.at(-1)); 
      }, 0);
     
    } catch {
      this.snackBar.error('Failed to request more scripts');
    } finally {
      this.loadingMoreScripts = false;
    }
  }

  async promptRequestScript() {
    const confirmed = await this.confirmDialog.open({
      title: 'Request New Script?',
      message: 'Assessment submitted successfully.<br>Would you like to request a new script?',
      confirmText: 'Yes, Request Script',
      cancelText: 'No, I\'m done',
      size: 'lg',
      centered: true,
      confirmButtonClass: 'btn-primary'
    });

    if (confirmed) {
      this.requestMoreScripts();
    }
  }

}
